// extracted by mini-css-extract-plugin
export default {"AppViewer":"QLzw7","loader":"XeabG"};